import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { Modal } from '../modal.tsx'

export type FormModalBodyProps = PropsWithChildren<{
  className?: string
}>

export const FormModalBody = ({ children, className }: FormModalBodyProps) => {
  return (
    <Modal.Body className={cn('pt-2 pb-6 px-8', className)}>
      {children}
    </Modal.Body>
  )
}
